import React, { useState, useRef, useEffect } from 'react';
import { useDemo } from '../../contexts/DemoContext';
import Icon from '../AppIcon';

const ScenarioSelector = () => {
  const { isDemoModeActive, profiles, selectedProfile, selectProfile, loadingProfiles } = useDemo();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  if (!isDemoModeActive) return null;

  const selectedProfileInfo = profiles.find(p => p.id === selectedProfile);

  const handleSelect = (profileId) => {
    selectProfile(profileId);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        <Icon name="ChevronDown" size={16} className={isOpen ? 'transform rotate-180' : ''} />
        <span>{loadingProfiles ? 'Loading...' : (selectedProfileInfo?.name || 'Select Profile')}</span>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50">
          <div className="py-1">
            {loadingProfiles ? (
              <div className="px-4 py-2 text-sm text-gray-500">Loading profiles...</div>
            ) : profiles.length === 0 ? (
              <div className="px-4 py-2 text-sm text-gray-500">No profiles available</div>
            ) : (
              profiles.map((profile) => (
                <button
                  key={profile.id}
                  onClick={() => handleSelect(profile.id)}
                  className={`w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors ${
                    selectedProfile === profile.id ? 'bg-blue-50 border-l-4 border-blue-500' : ''
                  }`}
                >
                  <div className="font-medium text-sm text-gray-900">{profile.name}</div>
                  {profile.description && (
                    <div className="text-xs text-gray-500 mt-1">{profile.description}</div>
                  )}
                  {profile.ageRange && (
                    <div className="text-xs text-gray-400 mt-1">Age: {profile.ageRange}</div>
                  )}
                </button>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ScenarioSelector;

